import pvhApi from '@/api/pvhApi'

import router from '@/router'

const state = () => ({
  orderType: {
    name: '',
    is_entity: false,
    statuses: [],
    selectedStatuses: []
  },
  validation: {
    name: { type: null, message: '' }
  },
  isLoading: true
})

const getters = {
  '[pvh] getOrderTypeForUpdate': state => state.orderType,
  '[pvh] getOrderTypeUpdateValidation': state => state.validation,
  '[pvh] getOrderTypeUpdateIsLoading': state => state.isLoading
}

const mutations = {
  '[pvh] GET_ORDER_TYPE': (state, orderType) => {
    state.orderType = orderType
  },
  '[pvh] GET_ORDER_TYPE_FOR_UPDATE': (state, orderType) => {
    state.orderType = {
      ...orderType,
      selectedStatuses: orderType.statuses ? orderType.statuses.map(status => {
        return {
          name: status.name,
          sort_order: status.pivot.sort_order,
          id: status.pivot.status_id,
          is_client_informing: status.pivot.is_client_informing,
          is_worker_informing: status.pivot.is_worker_informing,
          is_manual: status.is_manual,
          is_close: status.is_close,
          is_shaping: status.is_shaping,
          is_through: status.is_through,
          is_pay_informing: status.is_pay_informing,
          is_rollback: status.is_rollback,
          is_calculate: status.is_calculate
        }
      }) : []
    }

    state.isLoading = false
  },
  '[pvh] SET_ORDER_TYPE_UPDATE_NAME': (state, value) => {
    state.orderType.name = value
  },
  '[pvh] SET_ORDER_TYPE_UPDATE_ENTITY': (state) => {
    state.orderType.is_entity = !state.orderType.is_entity
  },
  '[pvh] SET_ORDER_TYPE_UPDATE_WORKER_INFORMING': (state, itemId) => {
    state.orderType.selectedStatuses.forEach(e => {
      if (e.id === itemId) e.is_worker_informing = !e.is_worker_informing
    })
  },
  '[pvh] SET_ORDER_TYPE_UPDATE_CLIENT_INFORMING': (state, itemId) => {
    state.orderType.selectedStatuses.forEach(e => {
      if (e.id === itemId) e.is_client_informing = !e.is_client_informing
    })
  },

  '[pvh] SET_ORDER_TYPE_ITEM_VALIDATION': (state, valid) => {
    if (valid?.name) {
      state.validation.name.message = valid.name[0]
      state.validation.name.type = 'error'
    }
  },

  '[pvh] ORDER_TYPE_UPDATE_CLEAR_VALIDATION': (state, inputName) => {
    // свитч кейсом очищать валидацию в нужном поле по имени инпута
    switch (inputName) {
      case 'name':
        state.validation.name = { type: null, message: '' }
        break
      default:
        break
    }
  },

  '[pvh] SET_ORDER_TYPE_UPDATE_INITIAL_STATE': (state, statusesList) => {
    state.orderType = {
      name: '',
      is_entity: false,
      selectedStatuses: [],
      statuses: statusesList?.map(status => {
        return {
          name: status.name,
          id: status.id,
          sort_order: status.id,
          is_client_informing: false,
          is_worker_informing: false
        }
      })
    }
  },
  '[pvh] SET_ORDER_TYPE_UPDATE_STATUSES_OPTIONS': (state, statusesList) => {
    const result = statusesList.map(status => {
      return {
        name: status.name,
        id: status.id,
        sort_order: status.id,
        is_client_informing: status.is_client_informing,
        is_worker_informing: status.is_worker_informing,
        is_manual: status.is_manual,
        is_close: status.is_close,
        is_shaping: status.is_shaping,
        is_through: status.is_through,
        is_pay_informing: status.is_pay_informing,
        is_rollback: status.is_rollback,
        is_calculate: status.is_calculate
      }
    })
    const select = result.filter(function (v) {
      return !state.orderType.selectedStatuses.some(function (v2) {
        return v.id === v2.id
      })
    })
    state.orderType.statuses = select
    state.isLoading = false
  }

}

const actions = {
  '[pvh] getOrderTypeUpdateInfo' ({ commit, state }, id) {
    const params = {
      expands: 'expand=statuses',
      id
    }

    pvhApi.getOrderTypeUpdateInfo(params).then(response => {
      commit('[pvh] GET_ORDER_TYPE_FOR_UPDATE', response.data.data)
    }).catch(error => {
      console.log('ошибка получения клиента', error)
    })
  },
  '[pvh] orderTypeUpdateSetName' ({ commit }, value) {
    commit('[pvh] SET_ORDER_TYPE_UPDATE_NAME', value)
  },
  '[pvh] orderTypeUpdateSetSurname' ({ commit }, value) {
    commit('[pvh] SET_ORDER_TYPE_UPDATE_SURNAME', value)
  },
  '[pvh] orderTypeUpdateSetPatronymic' ({ commit }, value) {
    commit('[pvh] SET_ORDER_TYPE_UPDATE_PATRONYMIC', value)
  },
  '[pvh] orderTypeUpdateSetAddress' ({ commit }, value) {
    commit('[pvh] SET_ORDER_TYPE_UPDATE_ADDRESS', value)
  },
  '[pvh] orderTypeUpdateSetPhone' ({ commit }, value) {
    commit('[pvh] SET_ORDER_TYPE_UPDATE_PHONE', value)
  },
  '[pvh] orderTypeUpdateSetInformer' ({ commit }, value) {
    commit('[pvh] SET_ORDER_TYPE_UPDATE_INFORMER', value)
  },
  '[pvh] orderTypeUpdateSetComment' ({ commit }, value) {
    commit('[pvh] SET_ORDER_TYPE_UPDATE_COMMENT', value)
  },
  '[pvh] orderTypeUpdateSetEmail' ({ commit }, value) {
    commit('[pvh] SET_ORDER_TYPE_UPDATE_EMAIL', value)
  },

  '[pvh] orderTypeUpdateClearValidation' ({ commit }, inputName) {
    commit('[pvh] ORDER_TYPE_UPDATE_CLEAR_VALIDATION', inputName)
  },
  '[pvh] orderTypeUpdateSaveInfo' ({ commit, state }, id) {
    const orderTypeData = {
      name: state.orderType.name,
      is_entity: state.orderType.is_entity,
      statuses: state.orderType.selectedStatuses.map((status, index) => {
        return {
          status_id: status.id,
          sort_order: index + 1,
          is_client_informing: status.is_client_informing ? status.is_client_informing : false,
          is_worker_informing: status.is_worker_informing ? status.is_worker_informing : false
        }
      })
    }
    if (id === 'create') {
      pvhApi.postOrderTypeUpdateSaveInfo(orderTypeData).then(response => {
        router.push({ name: 'PvhOrderTypeList' })
      }).catch(error => {
        commit('[pvh] SET_ORDER_TYPE_ITEM_VALIDATION', error.response.data.validation)
        console.log('Ошибка обновления типа заказа', error.response)
      })
    } else {
      pvhApi.putOrderTypeUpdate(orderTypeData, id).then(response => {
        router.push({ name: 'PvhOrderTypeList' })
      }).catch(error => {
        commit('[pvh] SET_ORDER_TYPE_ITEM_VALIDATION', error.response.data.validation)
        console.log('Ошибка обновления типа заказа', error.response)
      })
    }
  },
  '[pvh] setOrderTypeUpdateStatusesOptions' ({ commit, state }) {
    const params = {
      take: 100,
      page: 1,
      perPage: 5000,
      searchFilter: state.searchValue ? `?search[all]=${state.searchValue}` : ''
    }
    pvhApi.getStatusList(params)
      .then(response => {
        commit('[pvh] SET_ORDER_TYPE_UPDATE_STATUSES_OPTIONS', response.data.data)
      })
      .catch(error => {
        console.log('Ошибка получения списка клиентов', error)
      })
  },
  '[pvh] setOrderTypeUpdateInitialState' ({ commit }) {
    commit('[pvh] SET_ORDER_TYPE_UPDATE_INITIAL_STATE')
  },

  '[pvh] setOrderTypeUpdateItemsNewPosition' ({ commit, state }, { collection, dropResult }) {
    const arrayMove = (arr, oldIndex, newIndex) => {
      arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0])
      return arr
    }
    const { removedIndex, addedIndex } = dropResult

    if (removedIndex !== null && addedIndex !== null) {
      if (collection === 'items1') {
        state.orderType.selectedStatuses = arrayMove([...state.orderType.selectedStatuses], removedIndex, addedIndex)
      } else {
        state.orderType.statuses = arrayMove([...state.orderType.statuses], removedIndex, addedIndex)
      }
    } else if (removedIndex !== null && addedIndex === null) {
      if (collection === 'items1') {
        state.orderType.selectedStatuses.splice(removedIndex, 1)
      } else {
        state.orderType.statuses.splice(removedIndex, 1)
      }
    } else if (removedIndex === null && addedIndex !== null) {
      const item = state.orderType.pickedItem
      if (collection === 'items1') {
        state.orderType.selectedStatuses.splice(addedIndex, 0, item)
        state.orderType.selectedStatuses[addedIndex].sort_order = addedIndex
        state.orderType.pickedItem = {}
      } else {
        state.orderType.statuses.splice(addedIndex, 0, item)
        state.orderType.statuses[addedIndex].sort_order = addedIndex
        state.orderType.pickedItem = {}
      }
    }
  },

  '[pvh] pickOrderTypeUpdateItem' ({ commit, state }, dragResult) {
    const getItem = (arr, oldIndex) => {
      return arr[oldIndex]
    }

    if (dragResult.payload.group === 'second') {
      const itemId = getItem(state.orderType.statuses, dragResult.payload.index).id
      state.orderType.pickedItem = state.orderType.statuses.find(status => status.id === itemId)
    } else {
      const itemId = getItem(state.orderType.selectedStatuses, dragResult.payload.index).id
      state.orderType.pickedItem = state.orderType.selectedStatuses.find(status => status.id === itemId)
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
